import { ExpandedContent, Separator } from "../../Compartilhado/styles";
import { IItemHistorico } from "../../../../types";
import { DadosDemandaCriada } from "./types";
import { mapearDadosProposta, mapearPartes, mapearEmail } from "./utils";
import { mapearAnexos } from "../../Compartilhado/utils";
import BlocoPrincipal from "./Blocos/BlocoPrincipal/index";
import BlocoPartes from "./Blocos/BlocoPartes/index";
import BlocoAnexos from "../../Compartilhado/Blocos/BlocoAnexos";
import BlocoEmail from "./Blocos/BlocoEmail/index";
import LogsVazio from "../../Compartilhado/LogsVazio";
import { useLogHistorico } from "../../Hooks/useLogHistorico";

interface ExpandedContentProps {
    item: IItemHistorico;
    isExpanded?: boolean;
    onNavigateToFile?: (fileId: number) => void;
}

export default function ExpandedContentDemandaCriada({ item, isExpanded, onNavigateToFile }: ExpandedContentProps) {
    const { dados, loading } = useLogHistorico<DadosDemandaCriada>({
        itemId: item.id,
        isExpanded,
        mapearDados: (logs) => {
            const logProposta = logs.find((log: any) => log.entidade_nome === "proposta");
            if (logProposta && logProposta.dados_depois) {
                let campos = mapearDadosProposta(logProposta.dados_depois);
                const partes = mapearPartes(logs);
                const anexos = mapearAnexos(logs);
                const email = mapearEmail(logs);

                const acaoLower = (item.acao_original || item.acao || "").toLowerCase();
                const isDuplicacao = acaoLower.includes("duplicou") 
                    || acaoLower.includes("duplicação") 
                    || acaoLower.includes("duplicacao")
                    || acaoLower.includes("demanda criada por duplicação")
                    || acaoLower.includes("demanda criada por duplicacao");

                if (isDuplicacao) {
                    let dadosExtra = logProposta.dados_extra;
                    if (typeof dadosExtra === "string") {
                        try {
                            dadosExtra = JSON.parse(dadosExtra);
                        } catch (e) {
                            console.error("Erro ao fazer parse de dados_extra:", e);
                        }
                    }
                    
                    const idDemandaOriginal = dadosExtra?.id_demanda_original || dadosExtra?.id_proposta_original || dadosExtra?.demanda_original_id;
                    
                    if (idDemandaOriginal) {
                        campos.unshift({
                            campo: "Origem da demanda",
                            valor: `#${idDemandaOriginal}`
                        });
                    } else {
                        campos.unshift({
                            campo: "Origem da demanda",
                            valor: "Duplicação de demanda"
                        });
                    }
                }

                return {
                    campos,
                    partes,
                    anexos,
                    email
                };
            }

            return {
                campos: [],
                partes: [],
                anexos: [],
                email: null
            };
        },
        dadosVazios: {
            campos: [],
            partes: [],
            anexos: [],
            email: null
        }
    });

    if (loading) {
        return (
            <ExpandedContent>
                <div style={{ padding: '20px', textAlign: 'center', color: 'var(--c64748b)' }}>
                    Carregando dados...
                </div>
            </ExpandedContent>
        );
    }

    if (!dados) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    const temDadosValidos = dados.campos.length > 0 || dados.partes.length > 0 || dados.anexos.length > 0 || dados.email !== null;

    if (!temDadosValidos) {
        return (
            <ExpandedContent>
                <Separator />
                <LogsVazio />
            </ExpandedContent>
        );
    }

    return (
        <ExpandedContent>
            <Separator />
            <BlocoPrincipal campos={dados.campos} />
            <BlocoPartes partes={dados.partes} />
            <BlocoAnexos anexos={dados.anexos} onNavigateToFile={onNavigateToFile} />
            {dados.email && <BlocoEmail email={dados.email} />}
        </ExpandedContent>
    );
}

